import { render, staticRenderFns } from "./Provocadores.vue?vue&type=template&id=08543cba&scoped=true&lang=pug&"
import script from "./Provocadores.vue?vue&type=script&lang=js&"
export * from "./Provocadores.vue?vue&type=script&lang=js&"
import style0 from "./Provocadores.styl?vue&type=style&index=0&id=08543cba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08543cba",
  null
  
)

export default component.exports